import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { getGoogleChatMappingsUrl } from '../../utils/Url';
import integrations from '../utils/integrations';
import { jsx as _jsx } from "react/jsx-runtime";
const MapGoogleChatAccount = ({
  appId
}) => {
  if (!integrations.isGoogleChatAppId(appId)) {
    return undefined;
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: 'shareWithThirdPartyComponentLibrary.chatSpaceSelector.mapAccount_jsx',
    elements: {
      Link: UILink
    },
    options: {
      href: getGoogleChatMappingsUrl(),
      external: true
    }
  });
};
export default MapGoogleChatAccount;